import styled from '@emotion/styled';

export const StyledNotificationWrap = styled.div`
  margin-top: 18px;
`;

export const StyledNotificationArea = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 20px 40px;
  background: #fff;
  &:first-of-type {
    margin-top: 0;
  }

  & > strong {
    position: relative;
    display: block;
    width: 200px;
    font-size: 16px;
    line-height: 23px;
    color: #333;
  }
`;

export const StyledNotificationBox = styled.div`
  position: relative;
  width: calc(100% - 200px);
  padding-left: 32px;
  color: #555;

  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }

  & .txt-total_count {
    font-size: 12px;
    color: #ababab;
  }

  & .metatag-area {
    width: 300px;
  }
`;

export const StyledNotificationBoxFlex = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 32px;
  color: #555;
  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }
`;

export const StyledInputList = styled.ul`
  position: relative;
  & li {
    display: inline-block;
    margin: 8px 40px 8px 0;
  }
`;

export const StyledRadioList = styled.ul`
  li {
    height: 36px;
    display: flex;
    align-items: center;

    span.description {
      margin-left: 4px;
      color: #888888;
    }
  }
`;

export const StyledMetatag = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  /* width: 440px; */
  /* height: 35.5px; */
  /* margin-left: 45px; */
  /* margin-bottom: 19px; */

  & .title {
    display: flex;
    align-items: center;
    height: 40px;
    width: 220px;
    padding: 0 20px;
    font-size: 12px;
    font-weight: 600;
    border-left: 4px solid #7fe200;
    background-color: #00bf00;
    color: #fff;

    & + div {
      margin: 0 20px;
    }
  }
`;

export const StyledExcelRow = styled.div`
  display: flex;
  align-items: center;

  .tit {
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }

  & + & {
    margin-top: 16px;
  }

  & > * + * {
    margin-left: 10px;
  }
`;

export const StyledExcelButton = styled.button`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;

  height: 34px;
  padding: 0 16px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #00bf00;
  background-color: transparent;
  border: 1px solid #00bf00;

  input {
    display: none;
  }

  &:hover {
    color: white;
    background-color: #00bf00;
  }
`;
